import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { StaplesHeadhaulLane } from 'apps/marketplace/apiTypes/staplesHeadhaulLanes'
import { Table, TableHead, TableBody, TableCell, TableRow } from 'transfix-ui'
import { StaplesHeadhaulLanesTablesRow } from './StaplesheadhaulLanesTableRow'

enum TABLE_COLUMNS {
  createdAt = 'Created At',
  pickupCity = 'Pickup City',
  pickupState = 'Pickup State',
  deliveryCity = 'Delivery City',
  deliveryState = 'Delivery State',
  staplesCityLane = 'Staples City Lanes',
  transfixBackhaulLane = 'Transfix Backhaul Lane',
  carrier = 'Carrier',
  dailyTrucks = '# Daily Trucks',
  weeklyTrucks = '# Weekly Trucks',
  pickupWindow = 'Pickup Window',
  deliveryWindow = 'Delivery Window',
  actions = '',
}

interface IStaplesHeadhaulLanesTableProps {
  staplesHeadhaulLanes: StaplesHeadhaulLane[]
  onOpenDeleteConfirmation: (id: number) => void
  onOpenEditConfirmation: (id: number, existingData: StaplesHeadhaulLane) => void
}

export const StaplesHeadhaulLanesTable: FC<IStaplesHeadhaulLanesTableProps> = ({
  staplesHeadhaulLanes = [],
  onOpenDeleteConfirmation,
  onOpenEditConfirmation,
}) => {
  if (staplesHeadhaulLanes.length === 0) {
    return (
      <Box my={2} textAlign='center'>
        <Typography variant='h3'>No Staples Headhaul Lanes Found!</Typography>
      </Box>
    )
  }
  return (
    <Table>
      <TableHead>
        <TableRow tableCellType='th'>
          {Object.entries(TABLE_COLUMNS).map(([key, value]) => (
            <TableCell
              tableCellType='th'
              key={`${key}-column-header`}
              dataTest={`staples-${key}-column-header`}>
              {value}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody dataTest='staples-headhaul-lanes-table'>
        {staplesHeadhaulLanes.map(lane => (
          <StaplesHeadhaulLanesTablesRow
            key={lane.id}
            staplesHeadhaulLane={lane}
            onOpenDeleteConfirmation={onOpenDeleteConfirmation}
            onOpenEditConfirmation={onOpenEditConfirmation}
          />
        ))}
      </TableBody>
    </Table>
  )
}
